import {
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
  IonContent,
  IonImg,
  IonInput,
  IonItem,
  IonLabel,
  IonLoading,
  IonNote,
  IonPage,
  useIonToast,
} from '@ionic/react';
import { useContext, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router';
import { AppContext } from '../../lib/context/AppContext';

const SignUp: React.FC = (props) => {
  const { login, apiService } = useContext(AppContext);
  const [present] = useIonToast();
  const [loading, setLoading] = useState(false);
  let history = useHistory();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ reValidateMode: 'onChange', mode: 'onChange' });

  return (
    <IonPage>
      <IonContent fullscreen>
        <a href='/' className='fixed top-16 left-8 z-10'>
          <IonImg src={'/assets/icon/icon.png'} className='w-8' />
        </a>
        <IonLoading spinner='bubbles' isOpen={loading} />
        <div className='h-screen flex items-center justify-center bg-app'>
          <IonCard className='w-full max-w-md'>
            <IonCardHeader>
              <IonCardTitle>Crea account</IonCardTitle>
            </IonCardHeader>
            <IonCardContent>
              <form
                onSubmit={handleSubmit(async (data) => {
                  setLoading(true);
                  apiService?.post(`/auth/local/register`, data).then(
                    (response) => {
                      setLoading(false);
                      login(response.data.user, response.data.jwt);
                      history.replace('/');
                    },
                    (error) => {
                      setLoading(false);
                      present({
                        message:
                          error.response?.data?.error?.message ||
                          'Errore durante la registrazione',
                        duration: 2500,
                        position: 'top',
                        color: 'danger',
                      });
                    }
                  );
                })}
              >
                <IonItem
                  fill='solid'
                  className={`${!errors.username && 'ion-valid'} ${
                    !!errors.username && 'ion-invalid'
                  } `}
                >
                  <IonLabel position='floating'>Nome e Cognome</IonLabel>
                  <IonInput
                    type='text'
                    {...register('username', { required: true })}
                  ></IonInput>
                  <IonNote slot='error'>Nome e Cognome obbligatorio</IonNote>
                </IonItem>

                <IonItem
                  fill='solid'
                  className={`mt-4 ${!errors.email && 'ion-valid'} 
                  ${!!errors.email && 'ion-invalid'} 
                  `}
                >
                  <IonLabel position='floating'>Email</IonLabel>
                  <IonInput
                    type='email'
                    {...register('email', { required: true })}
                  ></IonInput>
                  <IonNote slot='error'>Email non valida</IonNote>
                </IonItem>

                <IonItem
                  fill='solid'
                  className={`mt-4 ${!errors.password && 'ion-valid'} 
                  ${!!errors.password && 'ion-invalid'} `}
                >
                  <IonLabel position='floating'>Password</IonLabel>
                  <IonInput
                    type='password'
                    {...register('password', { required: true, minLength: 6 })}
                  ></IonInput>
                  {errors.password?.type === 'minLength' && (
                    <IonNote slot='error'>
                      La password deve avere minimo 6 caratteri
                    </IonNote>
                  )}
                  {errors.password?.type === 'required' && (
                    <IonNote slot='error'>Password obbligatoria</IonNote>
                  )}
                </IonItem>

                <IonItem
                  fill='solid'
                  className={`mt-4 ${!errors.confirmPassword && 'ion-valid'} 
                  ${errors.confirmPassword && 'ion-invalid'} `}
                >
                  <IonLabel position='floating'>Conferma Password</IonLabel>
                  <IonInput
                    type='password'
                    {...register('confirmPassword', {
                      required: true,
                      minLength: 6,
                      validate: (value, fields) => value === fields.password,
                    })}
                  ></IonInput>
                  {errors.confirmPassword && (
                    <IonNote slot='error'>
                      Le password non corrispondono
                    </IonNote>
                  )}
                </IonItem>

                <div className='mt-8 flex justify-between'>
                  <div className='mt-2 text-xs text-neutral-400'>
                    Registrandoti accetti le:
                    <br />
                    <a
                      href='https://www.iubenda.com/privacy-policy/87173415'
                      target='_blank'
                      rel='noreferrer'
                      className='font-bold'
                    >
                      Privacy Policy
                    </a>{' '}
                    <span className='mx-1'>e</span>
                    <a
                      href='https://www.iubenda.com/termini-e-condizioni/87173415'
                      target='_blank'
                      rel='noreferrer'
                      className='font-bold'
                    >
                      Termini e condizioni
                    </a>
                  </div>
                  <IonButton type='submit'>Registrati</IonButton>
                </div>
              </form>

              <div className='border-top w-full h-[1px] bg-gray-300 my-4 relative'>
                <span className='bg-white absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 p-2'>
                  Hai un account?
                </span>
              </div>
              <div className='mt-8'>
                <IonButton routerLink='sign-in' expand='block' fill='clear'>
                  Accedi
                </IonButton>
              </div>
            </IonCardContent>
          </IonCard>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default SignUp;
